<div class="protocol-sstp">
  <div class="protocol-sstp__header">
    <app-details-header
      title="SSTP｜簡易飲水テスト"
      i18n-title="@@details.protocolSstp.headerTitle"
      badgeText="スクリーニング"
      i18n-badgeText="@@details.protocolSstp.headerBadge"
      [patientName]="patientName()"
      [measureDate]="measureDate()"
      [measurer]="measurer()" />
  </div>

  <div class="protocol-sstp__body">
    <!-- Warning Banner -->
    @if (hasWarning()) {
      <div class="warning-banner">
        <mat-icon class="warning-banner__icon">warning_amber</mat-icon>
        <div class="warning-banner__content">
          <span class="warning-banner__title" i18n="@@details.protocolSstp.warningTitle">問題を検出</span>
          <span class="warning-banner__desc" i18n="@@details.protocolSstp.warningDesc">飲水テストで飲み込めていない等の所見が検出されました。</span>
        </div>
      </div>
    }

    <!-- KPI Row: Result + Path -->
    <div class="kpi-row kpi-row--half">
      <!-- Overall Result Card -->
      <div class="kpi-card">
        <span class="kpi-card__title" i18n="@@details.protocolSstp.kpiOverallTitle">総合判定</span>
        <div class="kpi-card__main">
          <div class="result-indicator" [class.result-indicator--ok]="isStable()" [class.result-indicator--warn]="hasWarning()">
            <mat-icon class="result-indicator__icon">
              {{ isStable() ? 'check_circle' : 'warning' }}
            </mat-icon>
            <span class="result-indicator__label">{{ resultLabel() }}</span>
          </div>
        </div>
      </div>

      <!-- Path Card -->
      <div class="kpi-card">
        <span class="kpi-card__title" i18n="@@details.protocolSstp.kpiPathTitle">通過状況</span>
        <div class="kpi-card__main">
          <div class="path-list">
            <div class="path-item">
              <span class="path-item__label">5ml</span>
              <span class="path-item__value" [class.path-item__value--ok]="sstpPath().path5ml === 'C'" [class.path-item__value--warn]="sstpPath().path5ml && sstpPath().path5ml !== 'C'">
                {{ pathDescription5ml() }}
              </span>
            </div>
            <div class="path-item">
              <span class="path-item__label">30ml</span>
              <span class="path-item__value" [class.path-item__value--ok]="sstpPath().path30ml === 'C'" [class.path-item__value--warn]="sstpPath().path30ml && sstpPath().path30ml !== 'C'">
                {{ pathDescription30ml() }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Trial Detail Table (accordion) -->
    @if (trialRows().length) {
      <div class="attempt-card">
        <button
          type="button"
          class="attempt-card__header"
          [attr.aria-expanded]="trialsExpanded()"
          aria-controls="sstp-trial-table-body"
          (click)="toggleTrials()">
          <div class="attempt-card__header-left">
            <mat-icon class="attempt-card__icon">table_rows</mat-icon>
            <span class="attempt-card__title" i18n="@@details.protocolSstp.trialDetailTitle">試行詳細</span>
          </div>
          <mat-icon class="attempt-card__chevron" [class.attempt-card__chevron--open]="trialsExpanded()">
            expand_more
          </mat-icon>
        </button>

        @if (trialsExpanded()) {
          <div id="sstp-trial-table-body" class="attempt-card__table-wrap">
            <table class="attempt-card__table">
              <thead>
                <tr>
                  <th i18n="@@details.protocolSstp.tableHeaderTrial">試行</th>
                  <th i18n="@@details.protocolSstp.tableHeaderSwallow">嚥下の有無</th>
                  <th i18n="@@details.protocolSstp.tableHeaderCough">むせの有無</th>
                  <th i18n="@@details.protocolSstp.tableHeaderAbnormalSound">音の異常</th>
                  <th i18n="@@details.protocolSstp.tableHeaderDetail">詳細</th>
                </tr>
              </thead>
              <tbody>
                @for (trial of trialRows(); track trial.label; let i = $index) {
                  <tr [class.attempt-card__row--unmeasured]="!trial.measured">
                    <td class="attempt-card__cell--trial">{{ trial.label }}</td>
                    <td>
                      <span
                        class="attempt-badge"
                        [class.attempt-badge--normal]="!trial.swallowPresent"
                        [class.attempt-badge--abnormal]="trial.swallowPresent">
                        {{ trial.swallowLabel }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="attempt-badge"
                        [class.attempt-badge--normal]="!trial.coughPresent"
                        [class.attempt-badge--abnormal]="trial.coughPresent">
                        {{ trial.coughLabel }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="attempt-badge"
                        [class.attempt-badge--normal]="!trial.abnormalSoundPresent"
                        [class.attempt-badge--abnormal]="trial.abnormalSoundPresent">
                        {{ trial.abnormalSoundLabel }}
                      </span>
                    </td>
                    <td>
                      @if (trial.details.length) {
                        <button
                          type="button"
                          class="detail-toggle"
                          [attr.aria-expanded]="detailExpandedIndex() === i"
                          (click)="toggleDetail(i)">
                          <mat-icon class="detail-toggle__icon" [class.detail-toggle__icon--open]="detailExpandedIndex() === i">
                            expand_more
                          </mat-icon>
                        </button>
                      } @else {
                        <span class="attempt-card__empty-value">—</span>
                      }
                    </td>
                  </tr>
                  @if (trial.details.length && detailExpandedIndex() === i) {
                    <tr class="detail-row">
                      <td colspan="5">
                        <div class="detail-row__content">
                          @for (detail of trial.details; track detail.label) {
                            <div class="detail-row__item">
                              <span class="detail-row__label">{{ detail.label }}</span>
                              <span
                                class="attempt-badge attempt-badge--sm"
                                [class.attempt-badge--normal]="!detail.present"
                                [class.attempt-badge--abnormal]="detail.present">
                                {{ detail.displayLabel }}
                              </span>
                            </div>
                          }
                        </div>
                      </td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    }

    <!-- Wave + Posture + Event Timeline Card -->
    @if (showWaveCard()) {
      <div class="timeline-card">
        <div class="timeline-card__header">
          <div class="timeline-card__header-left">
            <mat-icon class="timeline-card__icon">graphic_eq</mat-icon>
            <span class="timeline-card__title">
              <span class="timeline-card__title-main" i18n="@@details.protocolSstp.timelineTitle">波形タイムライン</span>
              <span class="timeline-card__title-detail" i18n="@@details.protocolSstp.timelineSubtitle"> — 波形・姿勢・イベント</span>
            </span>
          </div>
          <span class="timeline-card__duration">
            <span i18n="@@details.protocolSstp.recordingDurationLabel">録音時間: </span>{{ recordData()?.data?.totalTime ?? '' }}
          </span>
        </div>

        <div class="timeline-card__grid">
          <div class="timeline-card__wave">
            <app-measured-data-wave-card
              [frameless]="true"
              [showMiniPlayback]="true"
              [recordData]="recordData()"
              [recordtype]="recordtype()"
              [recordLoadingSuccess]="recordLoadingSuccess()"
              [waveLoadingPercent]="waveLoadingPercent()"
              [waveErrorMessage]="waveErrorMessage()"
              [selectedEvent]="selectedEvent()"
              [currentStartOffset]="currentStartOffset()"
              [playing]="playing()"
              [timelineOffsetReference]="timelineOffsetReference()"
              [zoomValue]="zoomValue()"
              (offsetToggle)="offsetToggle.emit($event)"
              (seek)="seek.emit($event)"
              (playPauseClicked)="playPauseClicked.emit()"
              (zoomMinusClicked)="zoomMinusClicked.emit()"
              (zoomResetClicked)="zoomResetClicked.emit()"
              (zoomPlusClicked)="zoomPlusClicked.emit()" />
          </div>

          <div class="timeline-card__posture">
            <app-measured-data-neck-angle-card
              [frameless]="true"
              [chartOption]="chartOption()"
              [currentChartOption]="currentChartOption()"
              [currentOrientation]="currentOrientation()"
              (chartInit)="chartInit.emit($event)"
              (currentChartInit)="currentChartInit.emit($event)" />
          </div>

          <div class="timeline-card__events">
            <app-event-table
              [events]="events()"
              (seekToEvent)="onEventSeek($event)" />
          </div>

          <div class="timeline-card__footer">
            <app-data-footer
              [dataId]="dataId()"
              nbModel="nbModel v2.1"
              [downloadUrl]="downloadUrl()" />
          </div>
        </div>
      </div>
    }

    <!-- Disclaimer -->
    <app-disclaimer [message]="disclaimer" />
  </div>
</div>
